export const getOrgChannel = orgType => {
  return orgType > 0 ? 'testH1' : 'testG1';
};